import { enhancedApi } from '@store/generated/billing-v2';

import { V2_TAGS } from './v2-api';

export type {
  PaidClaimEvidenceItem,
  PaidClaimPaymentEvidence,
  PaidClaimResolutionCandidate,
  PaidClaimResolutionConflictResponse,
  PaidClaimResolutionHistoryItem,
  PaidClaimResolutionItem,
  PaidClaimResolutionReopenRequest,
  PaidClaimResolutionRequest,
  PaidClaimResolutionReviewResponse,
  PaidClaimServiceItem,
} from '@store/generated/billing-v2';
import type { PaidClaimResolutionReviewResponse } from '@store/generated/billing-v2';

const RESOLUTION_TAG = 'BillingPaidResolution';
const invalidatesSavedWork = (result?: PaidClaimResolutionReviewResponse) =>
  result
    ? ([
        { type: RESOLUTION_TAG, id: result.claim_id },
        { type: 'Claim' as const, id: result.claim_id },
        ...(result.encounter_id
          ? [{ type: 'BillingEncounter' as const, id: result.encounter_id }]
          : []),
        'BillingEncountersList',
        'BillingClaimsList',
        'ClaimQueueCounts',
        'BillingV2Tasks',
        V2_TAGS.CLAIM_WORK,
        V2_TAGS.CLAIM_WORK_COUNTS,
        V2_TAGS.CLAIMS,
        V2_TAGS.WORK,
        V2_TAGS.OVERVIEW,
      ] as const)
    : [];

/** Commands only refresh canonical surfaces after a successful server response. */
export const paidResolutionApi = enhancedApi.enhanceEndpoints({
  addTagTypes: [
    RESOLUTION_TAG,
    'Claim',
    'BillingEncounter',
    'BillingEncountersList',
    'BillingClaimsList',
    'ClaimQueueCounts',
    'BillingV2Tasks',
    ...Object.values(V2_TAGS),
  ],
  endpoints: {
    getV2ProviderBillingV2ClaimsByClaimIdPaidResolution: {
      providesTags: (result, _error, arg) => [
        { type: RESOLUTION_TAG, id: arg.claimId },
        // Visit Restore and workspace refresh must also refresh the archived/remaining-work state.
        ...(result?.encounter_id
          ? [{ type: 'BillingEncounter' as const, id: result.encounter_id }]
          : []),
      ],
    },
    postV2ProviderBillingV2ClaimsByClaimIdPaidResolutionResolve: {
      invalidatesTags: invalidatesSavedWork,
    },
    postV2ProviderBillingV2ClaimsByClaimIdPaidResolutionReopen: {
      invalidatesTags: invalidatesSavedWork,
    },
  },
});

export const {
  useGetV2ProviderBillingV2ClaimsByClaimIdPaidResolutionQuery: usePaidClaimResolutionQuery,
  usePostV2ProviderBillingV2ClaimsByClaimIdPaidResolutionResolveMutation:
    useResolvePaidClaimMutation,
  usePostV2ProviderBillingV2ClaimsByClaimIdPaidResolutionReopenMutation: useReopenPaidClaimMutation,
} = paidResolutionApi;
